import type * as ContextRelayModule from "@cytiva-dxda/ps-context-relay";

export type RelayModule = typeof ContextRelayModule;

let cached: RelayModule | null = null;

/**
 * Dynamically loads @cytiva-dxda/ps-context-relay via SystemJS.
 * Returns the module on success, or null if unavailable (404, network error, not deployed).
 * Idempotent — subsequent calls return the cached module without re-fetching.
 */
export async function loadRelay(): Promise<RelayModule | null> {
  if (cached) return cached;

  if (typeof window.System?.import !== "function") {
    console.warn(
      "[tracking] SystemJS is not available — ps-context-relay is disabled"
    );
    return null;
  }

  try {
    cached = await window.System.import<RelayModule>(
      "@cytiva-dxda/ps-context-relay"
    );
    return cached;
  } catch (err) {
    console.warn(
      "[tracking] ps-context-relay unavailable — relay is disabled:",
      err
    );
    return null;
  }
}

/**
 * Synchronous accessor for the cached module.
 * Returns null if the module has not been loaded yet or failed to load.
 */
export function getRelay(): RelayModule | null {
  return cached;
}
